module.exports = __webpack_public_path__ + "static/media/hot-tub.59d03927.svg";